/**
 * SCM provider identifiers — must match backend ``SCMProviderType`` and
 * ``repositories.provider`` in MongoDB.
 *
 * Values originate from the onboarding provider picker; never hardcode these
 * strings in API clients — always pass the user-selected ``ScmProviderId``.
 */
export type ScmProviderId = 'azure-devops' | 'github';

/** @deprecated Use ScmProviderId — kept for onboarding UI compatibility */
export type OnboardingProvider = ScmProviderId;

export function assertScmProvider(
  provider: ScmProviderId | null | undefined,
): ScmProviderId {
  if (provider !== 'azure-devops' && provider !== 'github') {
    throw new Error('SCM provider must be selected before calling the API');
  }
  return provider;
}

/** Infer provider from a repository URL when no explicit selection is available. */
export function inferScmProviderFromRepoUrl(repoUrl: string): ScmProviderId {
  const url = (repoUrl || '').trim().toLowerCase();
  if (url.includes('github.com')) {
    return 'github';
  }
  return 'azure-devops';
}
